// react
import React, { Suspense } from "react";

// components
import Spinner from "../../components/Spinner/ComponentLoader";

// load in the goal tree
const UserFeedbackPage = React.lazy(() => import("./UserFeedback"));

const UserFeedbackLazyLoader = () => (
	<Suspense fallback={<Spinner />}>
		<UserFeedbackPage />
	</Suspense>
);

export default UserFeedbackLazyLoader;
